
import { post, get } from '../utils/http';

export function getGooleConfig(param) {
    return get('general/config/get', param, 'default');
}
